import React, { FC, Dispatch, SetStateAction } from 'react'
import UploadIcon from 'svg/upload-v2.svg'
import styles from '../aboutArtist/AboutArtist.module.scss'
type NoResultsProps = {
  setShowUploader: Dispatch<SetStateAction<boolean>>
  showUploader: boolean
}

const NoResults: FC<NoResultsProps> = ({ showUploader, setShowUploader }) => {
  return (
    <div className={styles.noResultsWrapper}>
      <div className={styles.noResults}>
        <button
          type='button'
          title='Upload Studio Images'
          className={styles.uploadButton}
          onClick={() => setShowUploader(!showUploader)}
        >
          <UploadIcon />
          <p className={styles.uploadLabel}> add photos </p>
        </button>
      </div>
      <p className={styles.text}>
        Uploading your studio images gives collectors a better sense of you as an artist. Consider
        sharing images such as you in action in your studio, close-ups of materials,
        work-in-progress, and more.
      </p>
    </div>
  )
}

export default NoResults
